import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cancellations-and-refunds',
  templateUrl: './cancellations-and-refunds.component.html',
  styleUrls: ['./cancellations-and-refunds.component.scss']
})
export class CancellationsAndRefundsComponent implements OnInit {

  constructor() { }
  
  public companyName: string = environment.company;
  public contactEmail: string = environment.emails.contact_email;
  ngOnInit(): void {
  }

}
